import React from 'react';

const TechPack = () => {
	return (
		<div>
			<div className="all-template-select">
				<div className="custom-chekbox">
					<div className="form-group m-0">
						<input id="all_template" name="all" type="checkbox" />
						<label htmlFor="all_template">
							<span>ALL</span>
						</label>
					</div>
				</div>
				<button className="button text size32">
					<img alt="" src="/icons/download-gray-dark-02.svg" />
					<span className="gray_dark_02">Download</span>
				</button>
			</div>
			<div className="techpack-full-container">
				{/* Physical sample */}
				<div className="single-page-template">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input id="pSample" name="physical-sample" type="checkbox" />
							<label htmlFor="pSample" />
						</div>
					</div>
					<div className="header header-section">
						<div className="header-content">
							<div className="logo-area">
								<img
									alt="nitex"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAANCAYAAAAE0Vb3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgB3VZNbtNAFH4zdiuBgtTcYA6AGnMCUgnaLsMJkhwAJd4lq8QbqMTCCRygyQladqVdJEewwgV8g0ZQxKL1DN9z7ci4dlPxV9RPmtjzzcub+ebNe2OiB4Dzrtrip80/+864eRJ0pmXG+46vtKaWlDQ5CdyQuZeO7whNjZRL+2U+YDeH3Zzfd7f94Tq7i55qGSIlIjquvAsDKhGx+Zg6WFsV3W4sxhia7G5/UKeL117Rn66uSFmWHBDpObphTEbkCJnhVv1iaMwIsC0JcQc7SYEwdChsamLRz6qjcJm1+9ZXDYgdwNx9chDGfu10UAg9hCAqE7QOZ5/dCR7c6MVTvw7xMyysnfA3YIz2ThfusMxf5U0YXPSViwX7G4+IxbvpGHgffP3S0KvqQRimvFw5J1omgkp37V+j8jYc0XU0u197qs7HCkJmxEK+005WCGMlhoweQ4z3vwnC7rcp3mgaIEJHeFexkNyxY9jZDhJviGTn1986cncB8qa5V3v/PMtpHU3zx5J3/0tftQVRE82BuEIhDJknWFAaIUx2SH8V+qdmWcVWlqAahDTQlhuivGLaRWQaIWPkAIIoiqLSsv2rQAGY3lYAUpz3lEK1HSKpJ0aQA2oA7jifLwxZ5iSJEM6raUlLHtE9YVMQJzxdEnkQxRVtC9EpXI+8zREETa4F3Q/Si5OjwpHg+wSCxhhyuDzn7e11DlkQbveAjJwJ+oMQsrNXGzdv8KiqnxbuiI8XVzCIiaOSDkNQF0K4cHC5/phemIzkC0B7/BlRNu9Z4AYQtBNlSYsCo7lQJF8EGdg2hbgwPbYp8sfzxc+CMaxj9R9taIoNDPP5wZclFt4SHLUMfgAHGjW5NYUNTwAAAABJRU5ErkJggg=="
								/>
							</div>
							<div className="header-details">
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Style no</p>
										<p className="value">
											<span>:</span>
											<ss>HPWKT81</ss>
											<span className="ref-coll-part">-</span>
											<span className="ref-coll-part">CT-028</span>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Brand </p>
										<p className="value">
											<span>:</span>
											<ss>HERMES PARIS</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Product name</p>
										<p className="value">
											<span>:</span>
											<ss>Tank tops</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Market</p>
										<p className="value">
											<span>:</span>
											<ss>Women</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Sample size</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Size range</p>
										<p className="value">
											<span>:</span>
											<ss>
												3XS, 2XS, XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL,
												9XL, 10XL
											</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Season</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Fabric</p>
										<p className="value">
											<span>:</span>
											<ss>Knit</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Composition</p>
										<p className="value">
											<span>:</span>
											<ss>65% PES 35% RAY</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Created</p>
										<p className="value">
											<span>:</span>
											<ss>22-Apr-2022</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Country</p>
										<p className="value">
											<span>:</span>Bangladesh
										</p>
									</div>
									<div className="details-info">
										<p className="label">Supplier</p>
										<p className="value">
											<span>:</span>Nitex
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						{/* Physical sample With title without note */}
						<div className="techpack-body-content physical-sample-section  techpack-first">
							<div className="page-title">
								<h1>Physical sample</h1>
							</div>
							<div className="images-info">
								<div className="one-third first">
									<p>Front</p>
									<div className="photo">
										<img alt="" src="/images/t-shirt-orange.png" />
									</div>
								</div>
								<div className="one-third second">
									<p>Back</p>
									<div className="photo">
										<img alt="" src="/images/t-shirt-orange.png" />
									</div>
								</div>
							</div>
						</div>
						{/* Footer */}
						<div className="footer">
							<div className="footer-content">
								<p>Nitex design studio</p>
								<p>madewithlove@nitex.com | www.nitex.com</p>
								<p>
									Page <span>1</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* Key details */}
				<div className="single-page-template">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input id="kDetails" name="key-details" type="checkbox" />
							<label htmlFor="kDetails" />
						</div>
					</div>
					<div className="header header-section">
						<div className="header-content">
							<div className="logo-area">
								<img
									alt="nitex"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAANCAYAAAAE0Vb3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgB3VZNbtNAFH4zdiuBgtTcYA6AGnMCUgnaLsMJkhwAJd4lq8QbqMTCCRygyQladqVdJEewwgV8g0ZQxKL1DN9z7ci4dlPxV9RPmtjzzcub+ebNe2OiB4Dzrtrip80/+864eRJ0pmXG+46vtKaWlDQ5CdyQuZeO7whNjZRL+2U+YDeH3Zzfd7f94Tq7i55qGSIlIjquvAsDKhGx+Zg6WFsV3W4sxhia7G5/UKeL117Rn66uSFmWHBDpObphTEbkCJnhVv1iaMwIsC0JcQc7SYEwdChsamLRz6qjcJm1+9ZXDYgdwNx9chDGfu10UAg9hCAqE7QOZ5/dCR7c6MVTvw7xMyysnfA3YIz2ThfusMxf5U0YXPSViwX7G4+IxbvpGHgffP3S0KvqQRimvFw5J1omgkp37V+j8jYc0XU0u197qs7HCkJmxEK+005WCGMlhoweQ4z3vwnC7rcp3mgaIEJHeFexkNyxY9jZDhJviGTn1986cncB8qa5V3v/PMtpHU3zx5J3/0tftQVRE82BuEIhDJknWFAaIUx2SH8V+qdmWcVWlqAahDTQlhuivGLaRWQaIWPkAIIoiqLSsv2rQAGY3lYAUpz3lEK1HSKpJ0aQA2oA7jifLwxZ5iSJEM6raUlLHtE9YVMQJzxdEnkQxRVtC9EpXI+8zREETa4F3Q/Si5OjwpHg+wSCxhhyuDzn7e11DlkQbveAjJwJ+oMQsrNXGzdv8KiqnxbuiI8XVzCIiaOSDkNQF0K4cHC5/phemIzkC0B7/BlRNu9Z4AYQtBNlSYsCo7lQJF8EGdg2hbgwPbYp8sfzxc+CMaxj9R9taIoNDPP5wZclFt4SHLUMfgAHGjW5NYUNTwAAAABJRU5ErkJggg=="
								/>
							</div>
							<div className="header-details">
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Style no</p>
										<p className="value">
											<span>:</span>
											<ss>HPWKT81</ss>
											<span className="ref-coll-part">-</span>
											<span className="ref-coll-part">CT-028</span>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Brand </p>
										<p className="value">
											<span>:</span>
											<ss>HERMES PARIS</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Product name</p>
										<p className="value">
											<span>:</span>
											<ss>Tank tops</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Market</p>
										<p className="value">
											<span>:</span>
											<ss>Women</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Sample size</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Size range</p>
										<p className="value">
											<span>:</span>
											<ss>
												3XS, 2XS, XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL,
												9XL, 10XL
											</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Season</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Fabric</p>
										<p className="value">
											<span>:</span>
											<ss>Knit</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Composition</p>
										<p className="value">
											<span>:</span>
											<ss>65% PES 35% RAY</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Created</p>
										<p className="value">
											<span>:</span>
											<ss>22-Apr-2022</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Country</p>
										<p className="value">
											<span>:</span>Bangladesh
										</p>
									</div>
									<div className="details-info">
										<p className="label">Supplier</p>
										<p className="value">
											<span>:</span>Nitex
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						{/* Key details Full width image without note */}
						<div className="techpack-body-content without-note">
							<div className="page-title">
								<h1>Key details</h1>
							</div>
							<div className="full-image">
								<img alt="technical-details" src="/images/t-shirt-orange.png" />
							</div>
						</div>
						{/* Footer */}
						<div className="footer">
							<div className="footer-content">
								<p>Nitex design studio</p>
								<p>madewithlove@nitex.com | www.nitex.com</p>
								<p>
									Page <span>1</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* Material */}
				<div className="single-page-template">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input id="material" name="material" type="checkbox" />
							<label htmlFor="material" />
						</div>
					</div>
					<div className="header header-section">
						<div className="header-content">
							<div className="logo-area">
								<img
									alt="nitex"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAANCAYAAAAE0Vb3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgB3VZNbtNAFH4zdiuBgtTcYA6AGnMCUgnaLsMJkhwAJd4lq8QbqMTCCRygyQladqVdJEewwgV8g0ZQxKL1DN9z7ci4dlPxV9RPmtjzzcub+ebNe2OiB4Dzrtrip80/+864eRJ0pmXG+46vtKaWlDQ5CdyQuZeO7whNjZRL+2U+YDeH3Zzfd7f94Tq7i55qGSIlIjquvAsDKhGx+Zg6WFsV3W4sxhia7G5/UKeL117Rn66uSFmWHBDpObphTEbkCJnhVv1iaMwIsC0JcQc7SYEwdChsamLRz6qjcJm1+9ZXDYgdwNx9chDGfu10UAg9hCAqE7QOZ5/dCR7c6MVTvw7xMyysnfA3YIz2ThfusMxf5U0YXPSViwX7G4+IxbvpGHgffP3S0KvqQRimvFw5J1omgkp37V+j8jYc0XU0u197qs7HCkJmxEK+005WCGMlhoweQ4z3vwnC7rcp3mgaIEJHeFexkNyxY9jZDhJviGTn1986cncB8qa5V3v/PMtpHU3zx5J3/0tftQVRE82BuEIhDJknWFAaIUx2SH8V+qdmWcVWlqAahDTQlhuivGLaRWQaIWPkAIIoiqLSsv2rQAGY3lYAUpz3lEK1HSKpJ0aQA2oA7jifLwxZ5iSJEM6raUlLHtE9YVMQJzxdEnkQxRVtC9EpXI+8zREETa4F3Q/Si5OjwpHg+wSCxhhyuDzn7e11DlkQbveAjJwJ+oMQsrNXGzdv8KiqnxbuiI8XVzCIiaOSDkNQF0K4cHC5/phemIzkC0B7/BlRNu9Z4AYQtBNlSYsCo7lQJF8EGdg2hbgwPbYp8sfzxc+CMaxj9R9taIoNDPP5wZclFt4SHLUMfgAHGjW5NYUNTwAAAABJRU5ErkJggg=="
								/>
							</div>
							<div className="header-details">
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Style no</p>
										<p className="value">
											<span>:</span>
											<ss>HPWKT81</ss>
											<span className="ref-coll-part">-</span>
											<span className="ref-coll-part">CT-028</span>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Brand </p>
										<p className="value">
											<span>:</span>
											<ss>HERMES PARIS</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Product name</p>
										<p className="value">
											<span>:</span>
											<ss>Tank tops</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Market</p>
										<p className="value">
											<span>:</span>
											<ss>Women</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Sample size</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Size range</p>
										<p className="value">
											<span>:</span>
											<ss>
												3XS, 2XS, XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL,
												9XL, 10XL
											</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Season</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Fabric</p>
										<p className="value">
											<span>:</span>
											<ss>Knit</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Composition</p>
										<p className="value">
											<span>:</span>
											<ss>65% PES 35% RAY</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Created</p>
										<p className="value">
											<span>:</span>
											<ss>22-Apr-2022</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Country</p>
										<p className="value">
											<span>:</span>Bangladesh
										</p>
									</div>
									<div className="details-info">
										<p className="label">Supplier</p>
										<p className="value">
											<span>:</span>Nitex
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="techpack-body-content extra-fabric-details material-list without-note">
							<div className="page-title">
								<h1>Material list</h1>
							</div>
							<div className="fabric-details">
								<div className="fabric-details-table">
									<table>
										<thead>
											<tr>
												<th>SL</th>
												<th>Material</th>
												<th>Material type</th>
												<th>Quantity</th>
												<th>Description</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1</td>
												<td></td>
												<td>Extra fabric</td>
												<td>0.5 kg</td>
												<td>Nice to have it</td>
											</tr>
											<tr>
												<td>2</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>CARTON</td>
												<td>1.0 pcs</td>
												<td>Opened blank cardboard box</td>
											</tr>
											<tr>
												<td>3</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>HAND_TAG</td>
												<td>1.0 pcs</td>
												<td />
											</tr>
											<tr>
												<td>4</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>TAPE</td>
												<td>2.0 meter</td>
												<td>Cotton Canvas</td>
											</tr>
											<tr>
												<td>5</td>
												<td></td>
												<td>Extra fabric</td>
												<td>0.5 kg</td>
												<td>What will be the description</td>
											</tr>
											<tr>
												<td>6</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>PATCH</td>
												<td>1.0 pcs</td>
												<td />
											</tr>
											<tr>
												<td>7</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>MAIN_LABEL</td>
												<td>1.0 pcs</td>
												<td>Woven Fabric</td>
											</tr>
											<tr>
												<td>8</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>Extra fabric</td>
												<td>0.5 kg</td>
												<td>Organic &amp; sustainable</td>
											</tr>
											<tr>
												<td>9</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>ZIPPER</td>
												<td>0.2 cm</td>
												<td>Craft Quality Nylon</td>
											</tr>
											<tr>
												<td>10</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>BUTTONS</td>
												<td>7.0 pcs</td>
												<td>Natural Materials</td>
											</tr>
											<tr>
												<td>11</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>SIZE_LABEL</td>
												<td>1.0 pcs</td>
												<td>Taffeta Woven Fabric</td>
											</tr>
											<tr>
												<td>12</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>PATCH</td>
												<td>1.0 pcs</td>
												<td>Metal</td>
											</tr>
											<tr>
												<td>13</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>POLY_BAG</td>
												<td>1.0 pcs</td>
												<td>Plain Garment Packaging</td>
											</tr>
											<tr>
												<td>14</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>CARTON</td>
												<td>1.0 pcs</td>
												<td>Recycled and virgin paper</td>
											</tr>
											<tr>
												<td>15</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>BUTTONS</td>
												<td>5.0 pcs</td>
												<td>Natural core</td>
											</tr>
											<tr>
												<td>16</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>COMPOSITE_LABEL</td>
												<td>1.0 pcs</td>
												<td>Composite Laundry Labels</td>
											</tr>
											<tr>
												<td>17</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>ZIPPER</td>
												<td>5.0 cm</td>
												<td>Heavy Duty Metal Right Handed Zipper</td>
											</tr>
											<tr>
												<td>18</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>CARE_LABEL</td>
												<td>1.0 pcs</td>
												<td>Paper Label</td>
											</tr>
											<tr>
												<td>19</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>BUTTONS</td>
												<td>5.0 pcs</td>
												<td />
											</tr>
											<tr>
												<td>20</td>
												<td>
													<span className="material-image">2</span>
												</td>
												<td>Extra fabric</td>
												<td>0.5 kg</td>
												<td>Organic, Single Jersey, 100% Organic Cotton, 160 GSM</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						{/* Footer */}
						<div className="footer">
							<div className="footer-content">
								<p>Nitex design studio</p>
								<p>madewithlove@nitex.com | www.nitex.com</p>
								<p>
									Page <span>1</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* HOW TO MEASURE */}
				<div className="single-page-template">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input id="how-to-measure" name="how-to-measure" type="checkbox" />
							<label htmlFor="how-to-measure" />
						</div>
					</div>
					<div className="header header-section">
						<div className="header-content">
							<div className="logo-area">
								<img
									alt="nitex"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAANCAYAAAAE0Vb3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgB3VZNbtNAFH4zdiuBgtTcYA6AGnMCUgnaLsMJkhwAJd4lq8QbqMTCCRygyQladqVdJEewwgV8g0ZQxKL1DN9z7ci4dlPxV9RPmtjzzcub+ebNe2OiB4Dzrtrip80/+864eRJ0pmXG+46vtKaWlDQ5CdyQuZeO7whNjZRL+2U+YDeH3Zzfd7f94Tq7i55qGSIlIjquvAsDKhGx+Zg6WFsV3W4sxhia7G5/UKeL117Rn66uSFmWHBDpObphTEbkCJnhVv1iaMwIsC0JcQc7SYEwdChsamLRz6qjcJm1+9ZXDYgdwNx9chDGfu10UAg9hCAqE7QOZ5/dCR7c6MVTvw7xMyysnfA3YIz2ThfusMxf5U0YXPSViwX7G4+IxbvpGHgffP3S0KvqQRimvFw5J1omgkp37V+j8jYc0XU0u197qs7HCkJmxEK+005WCGMlhoweQ4z3vwnC7rcp3mgaIEJHeFexkNyxY9jZDhJviGTn1986cncB8qa5V3v/PMtpHU3zx5J3/0tftQVRE82BuEIhDJknWFAaIUx2SH8V+qdmWcVWlqAahDTQlhuivGLaRWQaIWPkAIIoiqLSsv2rQAGY3lYAUpz3lEK1HSKpJ0aQA2oA7jifLwxZ5iSJEM6raUlLHtE9YVMQJzxdEnkQxRVtC9EpXI+8zREETa4F3Q/Si5OjwpHg+wSCxhhyuDzn7e11DlkQbveAjJwJ+oMQsrNXGzdv8KiqnxbuiI8XVzCIiaOSDkNQF0K4cHC5/phemIzkC0B7/BlRNu9Z4AYQtBNlSYsCo7lQJF8EGdg2hbgwPbYp8sfzxc+CMaxj9R9taIoNDPP5wZclFt4SHLUMfgAHGjW5NYUNTwAAAABJRU5ErkJggg=="
								/>
							</div>
							<div className="header-details">
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Style no</p>
										<p className="value">
											<span>:</span>
											<ss>HPWKT81</ss>
											<span className="ref-coll-part">-</span>
											<span className="ref-coll-part">CT-028</span>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Brand </p>
										<p className="value">
											<span>:</span>
											<ss>HERMES PARIS</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Product name</p>
										<p className="value">
											<span>:</span>
											<ss>Tank tops</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Market</p>
										<p className="value">
											<span>:</span>
											<ss>Women</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Sample size</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Size range</p>
										<p className="value">
											<span>:</span>
											<ss>
												3XS, 2XS, XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL,
												9XL, 10XL
											</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Season</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Fabric</p>
										<p className="value">
											<span>:</span>
											<ss>Knit</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Composition</p>
										<p className="value">
											<span>:</span>
											<ss>65% PES 35% RAY</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Created</p>
										<p className="value">
											<span>:</span>
											<ss>22-Apr-2022</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Country</p>
										<p className="value">
											<span>:</span>Bangladesh
										</p>
									</div>
									<div className="details-info">
										<p className="label">Supplier</p>
										<p className="value">
											<span>:</span>Nitex
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="techpack-body-content technical-details-section without-note">
							<div className="page-title">
								<h1>How to measure</h1>
							</div>
							<div className="full-image">
								<img alt="technical-details" src="/images/t-shirt-orange.png" />
							</div>
						</div>
						{/* Footer */}
						<div className="footer">
							<div className="footer-content">
								<p>Nitex design studio</p>
								<p>madewithlove@nitex.com | www.nitex.com</p>
								<p>
									Page <span>1</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* Measurement chart */}
				<div className="single-page-template">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input id="measurement-chart" name="measurement-chart" type="checkbox" />
							<label htmlFor="measurement-chart" />
						</div>
					</div>
					<div className="header header-section">
						<div className="header-content">
							<div className="logo-area">
								<img
									alt="nitex"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAANCAYAAAAE0Vb3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgB3VZNbtNAFH4zdiuBgtTcYA6AGnMCUgnaLsMJkhwAJd4lq8QbqMTCCRygyQladqVdJEewwgV8g0ZQxKL1DN9z7ci4dlPxV9RPmtjzzcub+ebNe2OiB4Dzrtrip80/+864eRJ0pmXG+46vtKaWlDQ5CdyQuZeO7whNjZRL+2U+YDeH3Zzfd7f94Tq7i55qGSIlIjquvAsDKhGx+Zg6WFsV3W4sxhia7G5/UKeL117Rn66uSFmWHBDpObphTEbkCJnhVv1iaMwIsC0JcQc7SYEwdChsamLRz6qjcJm1+9ZXDYgdwNx9chDGfu10UAg9hCAqE7QOZ5/dCR7c6MVTvw7xMyysnfA3YIz2ThfusMxf5U0YXPSViwX7G4+IxbvpGHgffP3S0KvqQRimvFw5J1omgkp37V+j8jYc0XU0u197qs7HCkJmxEK+005WCGMlhoweQ4z3vwnC7rcp3mgaIEJHeFexkNyxY9jZDhJviGTn1986cncB8qa5V3v/PMtpHU3zx5J3/0tftQVRE82BuEIhDJknWFAaIUx2SH8V+qdmWcVWlqAahDTQlhuivGLaRWQaIWPkAIIoiqLSsv2rQAGY3lYAUpz3lEK1HSKpJ0aQA2oA7jifLwxZ5iSJEM6raUlLHtE9YVMQJzxdEnkQxRVtC9EpXI+8zREETa4F3Q/Si5OjwpHg+wSCxhhyuDzn7e11DlkQbveAjJwJ+oMQsrNXGzdv8KiqnxbuiI8XVzCIiaOSDkNQF0K4cHC5/phemIzkC0B7/BlRNu9Z4AYQtBNlSYsCo7lQJF8EGdg2hbgwPbYp8sfzxc+CMaxj9R9taIoNDPP5wZclFt4SHLUMfgAHGjW5NYUNTwAAAABJRU5ErkJggg=="
								/>
							</div>
							<div className="header-details">
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Style no</p>
										<p className="value">
											<span>:</span>
											<ss>HPWKT81</ss>
											<span className="ref-coll-part">-</span>
											<span className="ref-coll-part">CT-028</span>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Brand </p>
										<p className="value">
											<span>:</span>
											<ss>HERMES PARIS</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Product name</p>
										<p className="value">
											<span>:</span>
											<ss>Tank tops</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Market</p>
										<p className="value">
											<span>:</span>
											<ss>Women</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Sample size</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Size range</p>
										<p className="value">
											<span>:</span>
											<ss>
												3XS, 2XS, XS, S, M, L, XL, 2XL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL,
												9XL, 10XL
											</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Season</p>
										<p className="value">
											<span>:</span>
											<ss />
										</p>
									</div>
									<div className="details-info">
										<p className="label">Fabric</p>
										<p className="value">
											<span>:</span>
											<ss>Knit</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Composition</p>
										<p className="value">
											<span>:</span>
											<ss>65% PES 35% RAY</ss>
										</p>
									</div>
								</div>
								<div className="one-forth">
									<div className="details-info">
										<p className="label">Created</p>
										<p className="value">
											<span>:</span>
											<ss>22-Apr-2022</ss>
										</p>
									</div>
									<div className="details-info">
										<p className="label">Country</p>
										<p className="value">
											<span>:</span>Bangladesh
										</p>
									</div>
									<div className="details-info">
										<p className="label">Supplier</p>
										<p className="value">
											<span>:</span>Nitex
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="techpack-body-content extra-fabric-details measurement-chart without-note">
							<div className="page-title">
								<h1>Measurement chart</h1>
							</div>
							<div className="fabric-details">
								<div className="fabric-details-table">
									<table>
										<thead>
											<tr>
												<th>SL</th>
												<th>POM</th>
												<th>Tol(+/-)</th>
												<th>3XS</th>
												<th>2XS</th>
												<th>XS</th>
												<th>S</th>
												<th>M</th>
												<th>L</th>
												<th>XL</th>
												<th>2XL</th>
												<th>3XL</th>
												<th>4XL</th>
												<th>Grade</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>A</td>
												<td>Length</td>
												<td>5.00</td>
												<td>24.00</td>
												<td>25.50</td>
												<td>27.00</td>
												<td>28.50</td>
												<td>30.00</td>
												<td>31.50</td>
												<td>33.00</td>
												<td>34.50</td>
												<td>36.00</td>
												<td>37.50</td>
												<td>1.50</td>
											</tr>
											<tr>
												<td>B</td>
												<td>Zipper</td>
												<td>4.00</td>
												<td>23.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>C</td>
												<td>ARK</td>
												<td>5.00</td>
												<td>19.00</td>
												<td>21.50</td>
												<td>24.00</td>
												<td>26.50</td>
												<td>29.00</td>
												<td>31.50</td>
												<td>34.00</td>
												<td>36.50</td>
												<td>39.00</td>
												<td>41.50</td>
												<td>2.50</td>
											</tr>
											<tr>
												<td>D</td>
												<td>TDS</td>
												<td>4.00</td>
												<td>19.00</td>
												<td>20.75</td>
												<td>22.50</td>
												<td>24.25</td>
												<td>26.00</td>
												<td>27.75</td>
												<td>29.50</td>
												<td>31.25</td>
												<td>33.00</td>
												<td>34.75</td>
												<td>1.75</td>
											</tr>
											<tr>
												<td>E</td>
												<td>Chest</td>
												<td>4.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>31.00</td>
												<td>32.00</td>
												<td>33.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>F</td>
												<td>TRT</td>
												<td>4.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>32.00</td>
												<td>0.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
											<tr>
												<td>G</td>
												<td>Test</td>
												<td>5.00</td>
												<td>18.00</td>
												<td>20.25</td>
												<td>22.50</td>
												<td>24.75</td>
												<td>27.00</td>
												<td>29.25</td>
												<td>31.50</td>
												<td>33.75</td>
												<td>36.00</td>
												<td>38.25</td>
												<td>2.25</td>
											</tr>
											<tr>
												<td>H</td>
												<td>SCC</td>
												<td>4.00</td>
												<td>21.00</td>
												<td>22.00</td>
												<td>23.00</td>
												<td>24.00</td>
												<td>25.00</td>
												<td>26.00</td>
												<td>27.00</td>
												<td>28.00</td>
												<td>29.00</td>
												<td>30.00</td>
												<td>1.00</td>
											</tr>
											<tr>
												<td>I</td>
												<td>Shoulder</td>
												<td>5.00</td>
												<td>25.00</td>
												<td>27.00</td>
												<td>29.00</td>
												<td>31.00</td>
												<td>33.00</td>
												<td>35.00</td>
												<td>37.00</td>
												<td>39.00</td>
												<td>41.00</td>
												<td>43.00</td>
												<td>2.00</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						{/* Footer */}
						<div className="footer">
							<div className="footer-content">
								<p>Nitex design studio</p>
								<p>madewithlove@nitex.com | www.nitex.com</p>
								<p>
									Page <span>1</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TechPack;
